import React from 'react';
import PrimarySectionHeader from 'commonComponents/Headers/PrimarySectionHeader/PrimarySectionHeader';
import styles from './FactsAndNumbers.module.scss';

const FactsAndNumbers = ({ header, subheader, data, placeholder }) => {
  const images = ['pin', 'marker', 'house', 'law'];
  return ( 
    <section className={ styles.FactsAndNumbers }>
      <div className={ styles.content }>
        <PrimarySectionHeader
          { ...{ header, subheader } }
          anchor='facts-and-numbers'
        />
        <div className={ styles.facts }>          
          { data && data.map((fact, i) =>
            <Fact
              key={ fact.title }
              image={ images[i] }
              { ...fact }              
            />)
          }
        </div>
        { placeholder && <div className={ styles.placeholder }>*{ placeholder }</div> }
      </div>
    </section>
  );
};

const Fact = ({ title, items, image }) => {
  const classes = `${styles.Fact} ${styles[image]}`;
  return (
    <div className={ classes }>
      <h6>{ title }</h6>
      <ul>
        { items && items.map(item => <li key={item}>{ item }</li>) }
      </ul>
    </div>
  );
};
 
export default FactsAndNumbers;